"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionStorageStore = void 0;
class SessionStorageStore {
  store = sessionStorage;
  constructor(key = "webauto_auth_js_token") {
    this.key = key;
  }
  get() {
    const value = this.store.getItem(this.key);
    if (!value) {
      return Promise.resolve(null);
    }
    return Promise.resolve(JSON.parse(value));
  }
  set(value) {
    this.store.setItem(this.key, JSON.stringify(value));
    return Promise.resolve();
  }
  clear() {
    this.store.removeItem(this.key);
  }
}
exports.SessionStorageStore = SessionStorageStore;
//# sourceMappingURL=SessionStorageStore.js.map